import { Table } from "react-bootstrap";

export default function AllFilesTable({ blobList }) {
  console.log("AMAN TABLE TEST", blobList);
  // We get an array of objects from the parent component containing url and date upload
  // The name of the file is extracted from the url and will be displayed in the table as a link
  return (
    <Table striped bordered hover className="mb-0 small">
      <thead className="bg-medstar-primary text-white">
        <tr>
          <th>File Name</th>
          <th>Date Uploaded</th>
        </tr>
      </thead>
      <tbody>
        {blobList.map((blob, index) => {
          return (
            <tr key={index}>
              <td>
                {/* The name of the file will be a clickable link that will download the file when clicked */}
                <a href={blob.url} target="_blank" rel="noopener noreferrer">
                  {blob.url
                    .split("/")
                    [blob.url.split("/").length - 1].split("?")[0]
                    .split("_")
                    .slice(1)
                    .join("_")}
                </a>
              </td>
              <td>{blob.date_uploaded}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
